import { useEffect, useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';

export function ProductThumb({ src, alt }: { src: string | null; alt: string }) {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  return (
    <div className="size-10 shrink-0 overflow-hidden rounded-[10px] border border-[var(--color-hairline)] bg-[var(--color-surface-elevated)]">
      {src && !broken ? (
        <img
          src={src}
          alt={alt}
          className="size-full object-contain"
          loading="lazy"
          decoding="async"
          onError={() => setBroken(true)}
        />
      ) : (
        <div className="flex size-full items-center justify-center text-[var(--color-muted)]">
          <ImageIcon className="size-4" aria-hidden />
        </div>
      )}
    </div>
  );
}
